import { render } from "./Lovepod.vue?vue&type=template&id=653ce29a&scoped=true"
import script from "./Lovepod.vue?vue&type=script&lang=js"
export * from "./Lovepod.vue?vue&type=script&lang=js"

import "./Lovepod.vue?vue&type=style&index=0&id=653ce29a&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-653ce29a"]])

export default __exports__